var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 139,
    viewBox: "0 0 178 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 178,
    height: 139
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.903 0.435486H0.0967712V138.565H177.903V0.435486Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.744 29.6095H119.898",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.683 122.853C128.683 124.71 127.178 126.215 125.321 126.215C123.464 126.215 121.959 124.71 121.959 122.853C121.959 120.997 123.464 119.492 125.321 119.492C127.178 119.492 128.683 120.997 128.683 122.853Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.917 24.0524H102.725C98.6583 24.0524 95.3619 27.3491 95.3619 31.4155V124.031C95.3619 128.097 98.6583 131.394 102.725 131.394H147.917C151.984 131.394 155.28 128.097 155.28 124.031V31.4155C155.28 27.3491 151.984 24.0524 147.917 24.0524Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.807 80.1761V37.7429H103.835V113.003C103.835 113.353 104.106 113.637 104.439 113.637H146.203C146.536 113.637 146.807 113.353 146.807 113.003V80.13",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.442 103.106H131.595C133.15 103.106 134.406 101.833 134.392 100.278C134.329 92.9048 133.77 86.0275 128.813 83.5487H123.225C118.267 86.0275 117.708 92.9048 117.645 100.278C117.632 101.833 118.887 103.106 120.442 103.106Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.831 91.9303H118.206",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.813 75.7258H123.225V83.5487H128.813V75.7258Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.209 70.1381H121.828",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.019 70.1381V75.7258",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.225 75.7258H117.637L112.049 86.9013",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.194 78.5197H128.812",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8068 121.17H48.9793C43.129 121.17 38.3864 116.428 38.3864 110.577V99.8078C38.3864 93.9575 43.129 89.2148 48.9793 89.2148H70.1653C76.0157 89.2148 80.7583 93.9575 80.7583 99.8078",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3378 110.577H48.9793V99.8078",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1653 73.3253C70.1653 79.1757 65.4227 83.9183 59.5723 83.9183C53.722 83.9183 48.9793 79.1757 48.9793 73.3253",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2759 131.763H43.6829V121.17",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5891 65.5544C71.5891 58.8479 66.1524 53.4113 59.446 53.4113C52.7395 53.4113 47.3029 58.8479 47.3029 65.5544",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9598 67.0463H76.5211",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9928 121.17L75.4618 131.763H54.2758L64.8688 99.8078H86.0548L82.4336 110.848",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7583 121.17H75.4618V110.577H80.7583C83.6834 110.577 86.0548 112.949 86.0548 115.874C86.0548 118.799 83.6834 121.17 80.7583 121.17Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4986 20.9108V40.3304C22.4986 42.9896 24.6543 45.1452 27.3134 45.1452H32.2887V54.7747L41.9182 45.1452H56.5231C59.1821 45.1452 61.3379 42.9896 61.3379 40.3304V20.9108C61.3379 18.2515 59.1821 16.096 56.5231 16.096H27.3134C24.6543 16.096 22.4986 18.2515 22.4986 20.9108Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8997 31.9045L39.5108 35.5156L46.733 28.2934",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.194 48.629H139.968",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.194 56.7581H139.968",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.99bddbc92d8362ace6d563136b2baac6.svg";
export { ForwardRef as ReactComponent };